import { Component, Input, Output, EventEmitter } from '@angular/core';


// **************************************** CATEGORY LIST COMPONENT CLASS **************************************
@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent {

  @Input() categories;
  @Input() categoryParentId;
  @Output() change: EventEmitter<any> = new EventEmitter();
  mainCategories;


  // -- FUNC Constructor
  constructor() { }


  // -- FUNC Ng Do Check
  public ngDoCheck() {
    if(this.categories && !this.mainCategories) {
      this.mainCategories = this.categories.filter(category => category.parentId == this.categoryParentId); 
    }
  }


  // -- FUNC Stop Click Propogate
  public stopClickPropagate(event: any){
    if(window.innerWidth < 960){
      event.stopPropagation();
      event.preventDefault();
    }    
  }


  // -- FUNC Change Category 
  public changeCategory(event){
    this.change.emit(event);
  }

}
